// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"44e67deb","372":"684e412a","377":"1aeb9d26","738":"fb74279b","849":"8a865abb","856":"ec7914c7"}[chunkId] + ".chunk.js";
};